const getOperatorUserActionsChargePoint = (state) => {
  return state.main.operatorUserActionsState.operatorUserActionsChargePoint
}
const getOperatorUserActionsChargePointPaginationOffset = (state) => {
  return state.main.operatorUserActionsState
    .operatorUserActionsChargePointPaginationOffset
}
const getFetchOperatorUserActionsChargePointRequestState = (state) => {
  return state.main.operatorUserActionsState
    .fetchOperatorUserActionsChargePointRequestState
}
const getOperatorUserActionsFilters = (state) => {
  return state.main.operatorUserActionsState.operatorUserActionsFilters
}
const getOperatorUserActions = (state) => {
  return state.main.operatorUserActionsState.operatorUserActions
}
const getOperatorUserActionsPaginationOffset = (state) => {
  return state.main.operatorUserActionsState.operatorUserActionsPaginationOffset
}
const getFetchOperatorUserActionsRequestState = (state) => {
  return state.main.operatorUserActionsState
    .fetchOperatorUserActionsRequestState
}
const getOperatorUserActionsUser = (state) => {
  return state.main.operatorUserActionsState.operatorUserActionsUser
}
const getOperatorUserActionsUserPaginationOffset = (state) => {
  return state.main.operatorUserActionsState
    .operatorUserActionsUserPaginationOffset
}
const getFetchOperatorUserActionsUserRequestState = (state) => {
  return state.main.operatorUserActionsState
    .fetchOperatorUserActionsUserRequestState
}
const getOperatorUserActionsChargingToken = (state) => {
  return state.main.operatorUserActionsState.operatorUserActionsChargingToken
}

const getFetchOperatorUserActionsChargingTokenRequestState = (state) => {
  return state.main.operatorUserActionsState
    .fetchOperatorUserActionsChargingTokenRequestState
}

const getOperatorUserActionsChargingTokenPaginationOffset = (state) => {
  return state.main.operatorUserActionsState
    .operatorUserActionsChargingTokenPaginationOffset
}

const OperatorUserActionsSelectors = {
  getOperatorUserActionsChargePoint,
  getOperatorUserActionsChargePointPaginationOffset,
  getFetchOperatorUserActionsChargePointRequestState,
  getOperatorUserActionsFilters,
  getOperatorUserActions,
  getOperatorUserActionsPaginationOffset,
  getFetchOperatorUserActionsRequestState,
  getOperatorUserActionsUser,
  getOperatorUserActionsUserPaginationOffset,
  getFetchOperatorUserActionsUserRequestState,
  getOperatorUserActionsChargingToken,
  getFetchOperatorUserActionsChargingTokenRequestState,
  getOperatorUserActionsChargingTokenPaginationOffset,
}

export default OperatorUserActionsSelectors
